import { gql } from 'apollo-angular';

export const CREATE_PURCHASE_ORDER = gql`
  mutation createPurchaseOrder(
    $createPurchaseOrderInput: CreatePurchaseOrderInput!
  ) {
    createPurchaseOrder(createPurchaseOrderInput: $createPurchaseOrderInput) {
      id
      vendorId
      purchaseOrderNo
    }
  }
`;

export const UPDATE_PURCHASE_ORDER = gql`
  mutation updatePurchaseOrder($id: Int!, $input: UpdatePurchaseOrderInput!) {
    updatePurchaseOrder(id: $id, input: $input) {
      id
      vendorId
      purchaseOrderNo
    }
  }
`;

export const MARK_AS_APPROVED = gql`
  mutation markPurchaseOrderAsApproved($id: Int!) {
    markPurchaseOrderAsApproved(id: $id) {
      id
      vendorId
      status
      purchaseStatus
    }
  }
`;

export const GENERATE_PO_PDF = gql`
  mutation generatePoPdf($id: Int!) {
    generatePoPdf(id: $id)
  }
`;

export const CANCEL_PO = gql`
  mutation cancelPurchaseOrder($id: Int!) {
    cancelPurchaseOrder(id: $id) {
      id
      status
      purchaseStatus
    }
  }
`;

export const MARK_AS_ISSUED = gql`
  mutation markAsIssued($id: Int!) {
    markAsIssued(id: $id) {
      id
      status
      purchaseStatus
    }
  }
`;